<template>

	<Layout>
		<Sider hide-trigger id="sider" width="300" collapsed-width="10" breakpoint="xl">
			<Tree   :data="data2" :show-checkbox="true" ref="tree4" @on-check-change="treeChange" :check-strictly="true"
				:check-directly="true"></Tree>
		</Sider>
		<Layout>
			<Content>
				<div>
					<Form ref="form" :model="data" :label-width="120" label-position="right">
						<Row type="flex" justify="center" align="middle">
							<Col :span="5">
							<FormItem label="角色名称：" prop="roleName" label-for="roleName">
								<Input v-model="data.roleName" placeholder="请输入" element-id="roleName" />
							</FormItem>
							</Col>
							<Col :span="6">
							<FormItem label="角色Code：" prop="roleCode">
								<Select v-model="data.roleCode" placeholder="请选择权限" :label-in-value="true">
									<Option v-for="(item,index)  in baseRoleCodeData" :value="item.dictValue"
										:label="item.dictName" :key="index">{{item.dictName}}
									</Option>
								</Select>
							</FormItem>
							</Col>
							<Col :span="6" class="ivu-text-right">
							<!-- <Col  v-bind="grid" class="ivu-text-right"> -->
							<FormItem>
								<Button type="primary" @click="selectSubmit">查询</Button>
								<Button @click="handleReset('form')" style="margin-left: 20px">重置</Button>
							</FormItem>
							</Col>
						</Row>
					</Form>

					<Button type="success" ghost size="large" @click="roleMainAdd()">新增角色</Button>

					<Table :columns="columns1" :data="data1">
						<template slot="action" slot-scope="{ row, index }">
							<Button type="warning" ghost size="small" style="margin-right: 5px"
								@click="selectTreeMain(row)">配置菜单</Button>
							<Button type="info" ghost size="small" @click="roleMainEdit(row)">编辑</Button>
							<Button type="error" ghost size="small" @click="shenHe(row)">删除</Button>
						</template>
					</Table>
					<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage"
						show-total show-elevator next-text="下一页" />
				</div>

				<div>
					<Modal v-model="modal3" title="配置菜单" width="20%" :loading="submitting" @on-ok="menuConfig()">
						<Tree :data="data3" :show-checkbox="true" ref="tree1" :check-directly="true"></Tree>
					</Modal>
				</div>

				<div>
					<Modal v-model="modal1" title="角色新增" width="20%" :loading="submitting" @on-ok="roleViewAdd()">
						<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
							<FormItem label="角色名称：" prop="roleName">
								<Input v-model="modalformValidata.roleName" />
							</FormItem>
							<FormItem label="角色Code：" prop="roleCode">
								<Select v-model="modalformValidata.roleCode" placeholder="请选择权限" :label-in-value="true">
									<Option v-for="(item,index)  in baseRoleCodeData" :value="item.dictValue"
										:label="item.dictName" :key="index">{{item.dictName}}
									</Option>
								</Select>
							</FormItem>
						</Form>
					</Modal>
				</div>

				<div>
					<Modal v-model="modal2" title="角色编辑" width="20%" :loading="submitting" @on-ok="roleViewEdit()">
						<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
							<FormItem label="角色名称：" prop="roleName">
								<Input v-model="modalformValidata.roleName" />
							</FormItem>
							<FormItem label="角色Code：" prop="roleCode">
								<Select v-model="modalformValidata.roleCode" placeholder="请选择权限" :label-in-value="true">
									<Option v-for="(item,index)  in baseRoleCodeData" :value="item.dictValue"
										:label="item.dictName" :key="index">{{item.dictName}}
									</Option>
								</Select>
							</FormItem>
						</Form>
					</Modal>
				</div>


			</Content>
		</Layout>
	</Layout>


</template>
<script>
	//分页的初始参数
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y',
		roleName: null,
		roleCode: null,
		deptId: null,
	};

	import {
		getLeftDeptTreer,
		getDictList,
		getRoleList,
		roleAdd,
		roleEdit,
		roleDelete,
		getMenuTreer,
		roleConfigMenu,
		roleGetMenu,
		getLeftMenuTree

	} from '@/network/index.js';

	export default {
		name: "BaseRole",
		props: {

		},
		components: {

		},
		data() {
			return {
				columns1: [{
						title: '角色id',
						key: 'roleId',
					},
					{
						title: '角色名称',
						key: 'roleName'
					},
					{
						title: '角色Code',
						key: 'roleCode',
					},
					{
						title: '部门id',
						key: 'deptId'
					},
					{
						title: '操作',
						slot: 'action',
						width: 220,
						align: 'center'
					}

				],
				pageTotal: 0,
				pageNum: 1,
				pageSize: 10,
				data2: [], //部门树
				data3: [], //菜单树
				data: { //查询条件
					roleName: '',
					roleCode: '',
				},
				data1: [], //table中显示的数据
				baseRoleCodeData: [],
				modal1: false,
				modal2: false,
				modal3: false,
				submitting: true,
				checkId: true,
				menuRoleId: '',
				menus: '',
				modalformValidata: {
					roleId: '',
					deptId: '',
					roleName: '',
					roleCode: '',
				},
				ruleValidate: {
					roleName: [{
						required: true,
						message: '角色名称必须填写',
						trigger: 'blur'
					}],
					roleCode: [{
						required: true,
						message: '角色Code必须填写',
						trigger: 'blur'
					}],
				}

			}
		},
		created() {
			this.initData();

			//获取角色权限
			let paramterTemp = {
				dictCode: 'base_role_code',
			};
			getDictList(paramterTemp).then(res => {
					this.baseRoleCodeData.push({
						dictValue: '99999',
						dictName: '请选择'
					});
					for (var i = 0; i < res.data.obj.dataList.length; i++) {

						this.baseRoleCodeData.push({
							dictValue: res.data.obj.dataList[i].dictValue,
							dictName: res.data.obj.dataList[i].dictName
						});
					}

				})
				.catch(error => {});
		},
		methods: {
			//初始化部门信息
			initData() {
				getLeftDeptTreer().then(res => {
					//数据清空
					this.data2 = [];
					this.data2.push({
						deptId: res.data.obj.deptId,
						title: res.data.obj.title,
						children: res.data.obj.children,

						expand: true,
						selected: true,

					});
				});
				this.getRolelist(paramter);

			},
			//页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;

				this.initData()
			},

			//获角色列表
			getRolelist(paramter) {
				getRoleList(paramter).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								roleId: res.data.obj.dataList[i].roleId,
								roleName: res.data.obj.dataList[i].roleName,
								roleCode: res.data.obj.dataList[i].roleCode,
								deptId: res.data.obj.dataList[i].deptId,
								createTime: res.data.obj.dataList[i].createTime,
							});


						}

					})
					.catch(error => {});
			},

			//查询提交
			selectSubmit() {

				if (this.data.roleName != null && this.data.roleName != '') {
					paramter.roleName = this.data.roleName;
				}
				if (this.data.roleCode != null && this.data.roleCode != '') {
					paramter.roleCode = this.data.roleCode;
				}

				this.getRolelist(paramter);

			},

			//重置
			handleReset(name) {
				this.$refs[name].resetFields();
				paramter.roleName = null;
				paramter.roleCode = null;
			},



			roleMainEdit(row) {
				this.modal2 = true;

				this.modalformValidata.roleId = row.roleId;
				this.modalformValidata.deptId = row.deptId;
				this.modalformValidata.roleName = row.roleName;
				this.modalformValidata.roleCode = row.roleCode;
			},
			//角色编辑
			roleViewEdit() {
				if ('99999' == this.modalformValidata.roleCode || '' == this.modalformValidata.roleCode) {
					this.$Message.error("请选择角色Code！");
					return;
				}

				let paramter = {
					roleName: this.modalformValidata.roleName,
					roleCode: this.modalformValidata.roleCode,
					deptId: this.modalformValidata.deptId,
					rolePower: 'add,del,upd,quy',
				};
				roleEdit(this.modalformValidata.roleId, paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('角色编辑成功!');
							this.modal2 = false;
							//编辑后刷新数据
							let paramtertemp = {
								deptId: paramter.deptId,
							};
							this.getRolelist(paramtertemp);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('角色编辑失败，请联系管理员!');
					});
			},


			//角色新增 弹出模态框
			roleMainAdd() {
				//debugger;
				if (paramter.deptId == null) {
					this.$Message.error("请选择部门！");
					return;
				} else {
					this.modal1 = true;
					this.modalformValidata.deptId = paramter.deptId;
				}


			},



			//角色新增
			roleViewAdd() {
				if ('99999' == this.modalformValidata.roleCode || '' == this.modalformValidata.roleCode) {
					this.$Message.error("请选择角色Code！");
					return;
				}
 
				let paramter = {
					deptId: this.modalformValidata.deptId,
					roleName: this.modalformValidata.roleName,
					roleCode: this.modalformValidata.roleCode,
					rolePower: 'add,del,upd,quy',
				};


				roleAdd(paramter).then(res => {
						if (res.success == true) {
							this.$Message.success('角色添加成功!');
							this.modal1 = false;
							//添加后刷新数据
							let paramtertemp = {
								deptId: paramter.deptId,
							};
							this.getRolelist(paramtertemp);
						} else {
							this.$Message.error(res.message);
						}
					})
					.catch(error => {
						this.$Message.success('角色添加失败，请联系管理员!');
					});
			},

			// 选中树节点触发的方法
			handleSelectChange(root, node) {
				console.log('root' + root);
				console.log('node' + node);
			},



			// 树复选框发生改变--只能有一个被选中
			treeChange(arr, obj) {
				// 清空所有已选中的
				arr.forEach(item => {
					item.checked = false;
				});
				// 只选中最后一次选中的
				obj.checked = true;
				this.checkId = obj.deptId;
				paramter.deptId = obj.deptId;
				this.getRolelist(paramter);

				// debugger;
				// 　let choicesAll=this.$refs.tree4.getCheckedNodes; //方法的运用 getSelectedNodes也是如此用法
				// 　　　　console.log(choicesAll.title); 
			},

			//获取菜单树
			selectTreeMain(row) {
				this.modal3 = true;
				let paramter = {
					roleId: row.roleId,
				};
				this.menuRoleId = row.roleId;
				getLeftMenuTree(paramter).then(res => {
					//数据清空
					this.data3 = [];
					this.data3.push({
						menuId: res.data.obj.menuId,
						title: res.data.obj.title,
						children: res.data.obj.children,

						expand: true,
						selected: true,

					});
				});
			},


			//递归遍历树中被选中的节点
			selectCheckTree(obj) {

				if (obj.checked == true) {
					if (this.menus == '') {
						this.menus = obj.menuId;
					} else {
						this.menus = this.menus + ',' + obj.menuId;
					}
				}

				if (obj.children != null) {
					for (var i = 0; i < obj.children.length; i++) {
						this.selectCheckTree(obj.children[i]);
					}
				} else {
					return;
				}

			},

			//配置角色需要的菜单
			menuConfig() {
				//表里树获取 选择的菜单
				console.log(this.data3);
				this.selectCheckTree(this.data3[0]);
				let paramter = {
					menus: this.menus,
				};


				roleConfigMenu(this.menuRoleId, paramter).then(res => {
					if (res.success == true) {
						this.$Message.success('角色菜单配置成功!');
						this.modal3 = false;

					} else {
						this.$Message.error(res.message);
					}
				}).catch(error => {
					this.$Message.success('角色菜单配置失败，请联系管理员!');
				});
 

			}


		}
	}
</script>


<!-- <style lang="scss" scoped> -->
<style lang="scss">
	/* 让方形复选框变成圆形单选框样式，最好在树组件外套一个父盒子，在样式前加父级选择器，以免影响其他树组件  scoped去掉就无效*/

	// .ivu-checkbox-inner {
	// 	border-radius: 50px;
	// }
 

	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}

	.ivu-layout-sider {
		background: #ffffff;
	}

	#sider {
		background: #f7fbff;
	}
</style>
